import axios from "axios";
import api from "./api";
import { ERRORS } from "./constants";

export const isFloat = (value) => {
  return value === +value && value !== (value | 0);
};

export const convertToSlug = (name) => {
  return name
    .toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "");
};
export const formatDate = (date) =>
  new Date(new Date(date).setDate(new Date(date).getDate())).toLocaleDateString("pt-BR");

export const getArrayAverage = (array) => {
  // truncate average with ~~
  return ~~(array.reduce((total, next) => total + next.price, 0) / array.length);
};

export const getCategories = async () => {
  return await api.get("/category?limit=9999").then((resp) => resp.data);
};

export const getUserEstablishment = async (user) => {
  return await api.get(`/establishment?user=${user}&limit=9999`).then((resp) => resp.data);
};

export const getCategoriesChildren = async () => {
  return await api.get("/sub-category?limit=9999").then((resp) => resp.data);
};

export const AllEstablishment = async () => {
  let response = await api.get("/establishment?limit=9999");
  return { total: response.data.length, list: response.data };
};

export const getTeamAll = async () => {
  let response = await api.get("/user?role=admin&limit=9999");
  return { total: response.data.length, list: response.data };
};

export const getClientAll = async () => {
  let response = await api.get("/user?role=client&limit=9999&status=active");
  return { total: response.data.length, list: response.data };
};

export const getUserAll = async () => {
  let response = await api.get("/user?limit=9999");
  return { total: response.data.length, list: response.data };
};

export const getProductAll = async () => {
  let response = await api.get("/product?limit=9999");
  return { total: response.data.length, list: response.data };
};

export const getEstablishmentProducts = async (establishment) => {
  let response = await api.get(`/product?limit=9999&establishment=${establishment}`);
  return { total: response.data.length, list: response.data };
};

export const getClientReservationsAllByEstablishment = async (id) => {
  let response = await api.get(`/establishmentReservations?establishment=${id}&limit=9999`);
  return { total: response.data.length, list: response.data };
};

export const getAllClientReservationsCompleted = async () => {
  let response = await api.get(`/clientReservation/complete?limit=9999`);
  return { total: response.data.length, list: response.data };
};

export const getCepCoordinates = async (cep) => {
  return await axios
    .get(`https://viacep.com.br/ws/${cep}/json/`)
    .then(async function (response) {
      if (response.data.erro === true) {
        return { error: "Informe um cep válido" };
      }
      return await axios
        .get(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${cep}&key=AIzaSyDNS3zg6fBLAc_MhP2JrXS1v955jb8DxXI`
        )
        .then(function (res) {
          // console.log(res.data.results[0].geometry.location.lat);
          return {
            data: response.data,
            lat: res.data.results[0].geometry.location.lat,
            long: res.data.results[0].geometry.location.lng,
          };
        });
    })
    .catch(function (error) {
      return { error: ERRORS.genericMessage };
    });
};

export const getCategory = async () => {
  try {
    const categories = await api.get("/category").then((resp) => {
      resp.data.forEach((category) => {
        if (category.slug === "food") localStorage.setItem("@Reservei:establishmentFoodId", category._id);
        if (category.slug === "moda") localStorage.setItem("@Reservei:establishmentFashionId", category._id);
        if (category.slug === "pet") localStorage.setItem("@Reservei:establishmentPetId", category._id);
        if (category.slug === "beleza") localStorage.setItem("@Reservei:establishmentBeautyId", category._id);
        if (category.slug === "farmacia") localStorage.setItem("@Reservei:establishmentDrugStoreId", category._id);
        if (category.slug === "lazer") localStorage.setItem("@Reservei:establishmentRecreationId", category._id);
      });
    });
  } catch (error) {
    console.log("getCategory error", error.message);
  }
};
